"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_bootstrap_1 = require("react-bootstrap");
const axios_1 = __importDefault(require("axios"));
const helpers_1 = require("../../../../../shared/helpers");
const ModalSelect_1 = __importDefault(require("../../../pages/Statistics/ModalSelect"));
const AdvancedSearchService_1 = require("../../../../../shared/services/AdvancedSearchService");
const AppContextProvider_1 = require("../../../../../shared/contexts/AppContextProvider");
const AppYearRange_1 = __importDefault(require("../../../../../shared/components/AppYearRange"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const SearchContextProvider_1 = require("../../../../../shared/contexts/SearchContextProvider");
const hooks_1 = require("../../../../../shared/hooks");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const AdvancedSearchFilters = ({ input, isOpen, setIsOpen, onChange, opcoesResultadoRx }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = (0, react_i18next_1.useTranslation)();
    const [filterOptions, setFilterOptions] = (0, react_1.useState)();
    const [selectedLibraries, setSelectedLibraries] = (0, react_1.useState)([]);
    const [selectedTypeOfWork, setSelectedTypeOfWork] = (0, react_1.useState)([]);
    const [selectedCollection, setSelectedCollection] = (0, react_1.useState)([]);
    const [selectedPublicationPlace, setSelectedPublicationPlace] = (0, react_1.useState)();
    const [selectedLanguage, setSelectedLanguage] = (0, react_1.useState)();
    const [selectedInternLocation, setSelectedInternLocation] = (0, react_1.useState)();
    const [selectedPhysicalDesc, setSelectedPhysicalDesc] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [order, setOrder] = (0, react_1.useState)(undefined);
    const [itemsPerPage, setItemsPerPage] = (0, react_1.useState)(undefined);
    const [publicationYear, setPublicationYear] = (0, react_1.useState)(undefined);
    const [compPublicationYear, setCompPublicationYear] = (0, react_1.useState)(undefined);
    const [virtualLib, setVirtualLib] = (0, react_1.useState)('N');
    const [finalPublicationYear, setFinalPublicationYear] = (0, react_1.useState)(undefined);
    const { lang } = (0, AppContextProvider_1.useAppContext)();
    const { clearSearch } = (0, SearchContextProvider_1.useSearchContext)();
    const { getAll } = (0, hooks_1.usePrefiterParams)();
    const { id, id_biblioteca, id_colecao, tipo_obra, cr } = getAll();
    (0, react_1.useEffect)(() => {
        if (compPublicationYear !== 'entre' && finalPublicationYear) {
            setFinalPublicationYear(undefined);
        }
    }, [compPublicationYear]);
    const setInputs = (input) => {
        const { libraries = undefined, typeOfWork = undefined, collection = undefined, publicationPlace = undefined, language = undefined, internLocation = undefined, physicalDesc = undefined, order = undefined, itemsPerPage = undefined, publicationYear = undefined, compPublicationYear = undefined, virtualLib = undefined, finalPublicationYear = undefined } = input;
        setSelectedLibraries(libraries);
        setSelectedTypeOfWork(typeOfWork);
        setSelectedCollection(collection);
        setSelectedPublicationPlace(publicationPlace);
        setSelectedLanguage(language);
        setSelectedInternLocation(internLocation);
        setSelectedPhysicalDesc(physicalDesc);
        setOrder(order);
        setItemsPerPage(itemsPerPage);
        setPublicationYear(publicationYear);
        setCompPublicationYear(compPublicationYear);
        setVirtualLib(virtualLib);
        setFinalPublicationYear(finalPublicationYear);
    };
    (0, react_1.useEffect)(() => {
        if (input) {
            setInputs(input);
        }
    }, [input]);
    (0, react_1.useEffect)(() => {
        if (onChange && typeof onChange === 'function') {
            onChange({
                libraries: (selectedLibraries === null || selectedLibraries === void 0 ? void 0 : selectedLibraries.length) === (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.libraries.length) ? undefined : selectedLibraries,
                typeOfWork: (selectedTypeOfWork === null || selectedTypeOfWork === void 0 ? void 0 : selectedTypeOfWork.length) === (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.typeOfWorkList.length) ? undefined : selectedTypeOfWork,
                collection: (selectedCollection === null || selectedCollection === void 0 ? void 0 : selectedCollection.length) === (filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.collectionList.length) ? undefined : selectedCollection,
                publicationPlace: selectedPublicationPlace,
                language: selectedLanguage,
                internLocation: selectedInternLocation,
                physicalDesc: selectedPhysicalDesc,
                order,
                itemsPerPage,
                publicationYear,
                compPublicationYear,
                virtualLib,
                finalPublicationYear
            });
        }
    }, [selectedLibraries, selectedTypeOfWork, selectedCollection, selectedPublicationPlace, selectedLanguage, selectedInternLocation, selectedPhysicalDesc, order, itemsPerPage, publicationYear, compPublicationYear, virtualLib, finalPublicationYear]);
    (0, react_1.useEffect)(() => {
        const cancelTokenSrc = axios_1.default.CancelToken.source();
        const { token } = cancelTokenSrc;
        setLoading(true);
        (0, AdvancedSearchService_1.getFilterOptions)(id, id_biblioteca, id_colecao, tipo_obra, token).then((response) => {
            if (response) {
                const { data } = response;
                setFilterOptions(data);
            }
        }).catch((error) => {
            if (!axios_1.default.isCancel(error)) {
                helpers_1.APIHelper.tratarErro(error);
                console.log(error);
            }
        }).finally(() => setLoading(false));
        return () => {
            cancelTokenSrc.cancel();
        };
    }, [lang]);
    const handleChangeNumericValue = (setValue, value) => {
        const newValue = value.replace(/\D/g, '');
        setValue(newValue);
    };
    return (react_1.default.createElement(react_bootstrap_1.Collapse, { in: isOpen },
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_bootstrap_1.Row, { className: 'd-flex align-items-center' },
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Biblioteca')),
                        filterOptions !== undefined && ((_a = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.libraries) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (react_1.default.createElement(ModalSelect_1.default, { style: { width: '100%' }, fem: true, label: t('EstatisticaSelecionarBiblioteca'), title: t('EstatisticaSelecionarBiblioteca'), dataSource: filterOptions.libraries, 
                            // @ts-ignore
                            renderLabel: x => `${x.cod} - ${x.description || t('Desconhecido')}`, selectedItems: selectedLibraries, setSelectedItems: setSelectedLibraries, keyValue: "cod", keyName: "description", btnCleanSelection: true, todosI18nIndice: {
                                fem: 'filtrosPesquisaAvancadaTodos',
                            } })) : '')),
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('TipoObra')),
                        filterOptions !== undefined && ((_b = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.typeOfWorkList) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (react_1.default.createElement(ModalSelect_1.default, { style: { width: '100%' }, fem: true, label: t('TipoObra'), title: t('TipoObra'), dataSource: filterOptions.typeOfWorkList, 
                            // @ts-ignore
                            renderLabel: x => `${x.cod} - ${x.description || t('Desconhecido')}`, selectedItems: selectedTypeOfWork, setSelectedItems: setSelectedTypeOfWork, keyValue: "cod", keyName: "description", btnCleanSelection: true, todosI18nIndice: {
                                fem: 'filtrosPesquisaAvancadaTodos',
                            } })) : '')),
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Colecao')),
                        filterOptions !== undefined && ((_c = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.collectionList) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (react_1.default.createElement(ModalSelect_1.default, { style: { width: '100%' }, fem: true, label: t('Colecao'), title: t('Colecao'), dataSource: filterOptions.collectionList, 
                            // @ts-ignore
                            renderLabel: x => `${x.cod} - ${x.description || t('Desconhecido')}`, selectedItems: selectedCollection, setSelectedItems: setSelectedCollection, keyValue: "cod", keyName: "description", btnCleanSelection: true, todosI18nIndice: {
                                fem: 'filtrosPesquisaAvancadaTodos',
                            } })) : ''))),
            react_1.default.createElement(react_bootstrap_1.Row, { className: 'd-flex align-items-center' },
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('AnoPublicacao')),
                        react_1.default.createElement(AppYearRange_1.default, { onChange: ({ start, end, option }) => {
                                setPublicationYear(start);
                                setFinalPublicationYear(end);
                                setCompPublicationYear(option);
                            }, value: { start: publicationYear, end: finalPublicationYear === null || finalPublicationYear === void 0 ? void 0 : finalPublicationYear.toString(), option: compPublicationYear || '=' }, options: [
                                { key: '=', value: t('Igual') },
                                { key: '<', value: t('Menor') },
                                { key: '>', value: t('Maior') },
                                { key: 'entre', value: t('Entre') }
                            ], condSecondInput: ({ key, value }) => key === 'entre' }))),
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('LugarDePublicacao')),
                        filterOptions !== undefined && ((_d = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.publicationPlaceList) === null || _d === void 0 ? void 0 : _d.length) > 0 ? (react_1.default.createElement(ModalSelect_1.default, { style: { width: '100%' }, label: t('LugarDePublicacao'), title: t('LugarDePublicacao'), dataSource: filterOptions.publicationPlaceList, 
                            // @ts-ignore
                            renderLabel: x => `${x.cod} - ${x.description || t('Desconhecido')}`, selected: selectedPublicationPlace, setSelected: setSelectedPublicationPlace, keyValue: "cod", keyName: "description", multiple: false, btnCleanSelection: true, todosI18nIndice: {
                                fem: 'filtrosPesquisaAvancadaTodos',
                            } })) : '')),
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Idioma')),
                        filterOptions !== undefined && ((_e = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.languageList) === null || _e === void 0 ? void 0 : _e.length) > 0 ? (react_1.default.createElement(ModalSelect_1.default, { style: { width: '100%' }, label: t('Idioma'), title: t('Idioma'), dataSource: filterOptions.languageList, 
                            // @ts-ignore
                            renderLabel: x => `${x.cod} - ${x.description || t('Desconhecido')}`, selected: selectedLanguage, setSelected: setSelectedLanguage, keyValue: "cod", keyName: "description", multiple: false, btnCleanSelection: true, todosI18nIndice: {
                                fem: 'filtrosPesquisaAvancadaTodos',
                            } })) : ''))),
            react_1.default.createElement(react_bootstrap_1.Row, { className: 'd-flex align-items-center' },
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('LocalizacaoInterna')),
                        filterOptions !== undefined && ((_f = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.internLocation) === null || _f === void 0 ? void 0 : _f.length) > 0 ? (react_1.default.createElement(ModalSelect_1.default, { style: { width: '100%' }, label: t('LocalizacaoInterna'), title: t('LocalizacaoInterna'), dataSource: filterOptions.internLocation, 
                            // @ts-ignore
                            renderLabel: x => `${x.cod} - ${x.description || t('Desconhecido')}`, selected: selectedInternLocation, setSelected: setSelectedInternLocation, keyValue: "cod", keyName: "description", multiple: false, btnCleanSelection: true, todosI18nIndice: {
                                fem: 'filtrosPesquisaAvancadaTodos',
                            } })) : '')),
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('BibliotecaVirtual')),
                        react_1.default.createElement(react_bootstrap_1.FormControl, { value: cr || virtualLib, disabled: cr !== null, onChange: (e) => setVirtualLib(e.target.value), as: "select" },
                            react_1.default.createElement("option", { value: "S" }, t('Sim')),
                            react_1.default.createElement("option", { value: "N" }, t('Nao'))))),
                react_1.default.createElement(react_bootstrap_1.Col, { md: "4" },
                    react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('DescricaoFisica')),
                        filterOptions !== undefined && ((_g = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.physicalDescList) === null || _g === void 0 ? void 0 : _g.length) > 0 ? (react_1.default.createElement(ModalSelect_1.default, { style: { width: '100%' }, fem: true, label: t('DescricaoFisica'), title: t('DescricaoFisica'), dataSource: filterOptions.physicalDescList, 
                            // @ts-ignore
                            renderLabel: x => `${x.cod} - ${x.description || t('Desconhecido')}`, selected: selectedPhysicalDesc, setSelected: setSelectedPhysicalDesc, keyValue: "cod", keyName: "description", multiple: false, btnCleanSelection: true, todosI18nIndice: {
                                fem: 'filtrosPesquisaAvancadaTodos',
                            } })) : ''))),
            react_1.default.createElement(react_bootstrap_1.Row, { className: 'd-flex align-items-center justify-content-center p-2' },
                react_1.default.createElement("button", { type: "button", className: "btn-generic--segundo ml-0 ", onClick: e => clearSearch() },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrash, className: "mr-2" }),
                    ' ',
                    t('LimparFiltros'))))));
};
const mapStateToProps = (state) => ({
    opcoesResultadoRx: state.pesquisa.opcoesResultado,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps)(AdvancedSearchFilters);
